import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M.71 6.243A.71.71 0 0 1 0 5.536V.708A.707.707 0 0 1 .71 0h4.839a.71.71 0 0 1 .71.708.707.707 0 0 1-.71.707h-4.13v4.12a.707.707 0 0 1-.71.708"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M.71 6.243A.71.71 0 0 1 0 5.536V.708A.707.707 0 0 1 .71 0h4.839a.71.71 0 0 1 .71.708.707.707 0 0 1-.71.707h-4.13v4.12a.707.707 0 0 1-.71.708M5.549 23.943H.709A.71.71 0 0 1 0 23.236v-4.84a.707.707 0 0 1 .71-.707.71.71 0 0 1 .708.707v4.132h4.13a.71.71 0 0 1 .71.708.707.707 0 0 1-.71.707"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.549 23.943H.709A.71.71 0 0 1 0 23.236v-4.84a.707.707 0 0 1 .71-.707.71.71 0 0 1 .708.707v4.132h4.13a.71.71 0 0 1 .71.708.707.707 0 0 1-.71.707M23.29 23.943h-4.85a.71.71 0 0 1-.71-.707.707.707 0 0 1 .71-.708h4.141v-4.132a.706.706 0 0 1 .71-.707.71.71 0 0 1 .655.436.7.7 0 0 1 .054.271v4.84a.706.706 0 0 1-.71.707M23.29 6.243a.71.71 0 0 1-.709-.707v-4.12H18.44a.71.71 0 0 1-.71-.708.707.707 0 0 1 .71-.708h4.85a.71.71 0 0 1 .71.708v4.828a.706.706 0 0 1-.71.707M7.16 7.851a.7.7 0 0 1-.499-.21L3.433 4.428a.708.708 0 0 1 .502-1.21.7.7 0 0 1 .502.208l3.223 3.22a.707.707 0 0 1-.503 1.21z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.84 7.851a.71.71 0 0 1-.697-.846.7.7 0 0 1 .195-.362l3.237-3.218a.711.711 0 0 1 1.212.5.7.7 0 0 1-.208.502l-3.237 3.215a.7.7 0 0 1-.502.21M20.066 20.726a.7.7 0 0 1-.491-.207l-3.237-3.218a.708.708 0 0 1 .502-1.21.7.7 0 0 1 .502.208l3.226 3.23a.707.707 0 0 1-.503 1.208zM3.935 20.725a.71.71 0 0 1-.688-.837.7.7 0 0 1 .186-.36l3.228-3.23a.71.71 0 0 1 1.18.512.7.7 0 0 1-.181.49L4.437 20.52a.7.7 0 0 1-.502.206"
    }, null, -1)
  ]))]))
}
export default { render: render }